<template>
  <div class="full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">{{$t('notFound.home')}} </el-breadcrumb-item>
          <el-breadcrumb-item>FBA{{$t('fba.packList')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-collapse v-show="isActive">
            <el-row class="search-row">
              <el-col :span="6" class="display-row">
                <div class="query-title">{{$t('fba.logisticsCompany')}}:</div>
                <div class="flex1">
                  <el-select v-model="queryInfo.logisticeCompany" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                    <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.companyName">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{$t('orderList.orderList4')}}:</div>
                <div class="flex1">
                  <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.waybillNumber" size="small"
                    @keyup.enter.native="searchList"> </el-input>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{$t('fba.line')}}:</div>
                <div class="flex1">
                  <el-select v-model="queryInfo.route" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                    <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{$t('fba.packBatchNo')}}:</div>
                <div class="flex1">
                  <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.containerBatchNo" size="small"
                    @keyup.enter.native="searchList"> </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">{{$t('common.createStartDate')}}:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">{{$t('common.createEndDate')}}:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="10" style="margin-top: 5px;margin-left: 21px;">
              {{$t('feedback.feedback21')}}
            </el-col>
          </el-row>
          </el-collapse>
          <div class="search-row" style="display:flex;justify-content: space-between;">
            <div class="">
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}"
                @click="quickSearchList('',index = 0)">{{$t('common.all')}}</el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 7}"
                @click="quickSearchList('6',index = 7)">{{$t('fba.toPack')}}<span class="lx-red">({{orderData.waitBoxNum}})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}"
                @click="quickSearchList('0',index = 1)">{{$t('fba.packing')}}<span class="lx-red">({{orderData.boxingNum}})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 8}"
                @click="quickSearchList('7',index = 8)">{{$t('fba.finishBox')}}<span
                  class="lx-red">({{orderData.finishBoxNum}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}"
                @click="quickSearchList('1',index = 2)">{{$t('fba.toPay')}}<span class="lx-red">({{orderData.waitPayNum}})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}"
                @click="quickSearchList('2',index = 3)">{{$t('fba.toUploadInvoice')}}<span
                  class="lx-red">({{orderData.waitVoiceNum}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 4}"
                @click="quickSearchList('3',index = 4)">{{$t('fba.toSend')}}<span
                  class="lx-red">({{orderData.waitSendNum}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 5}"
                @click="quickSearchList('4',index = 5)">{{$t('fba.sent')}}</el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 6}"
                @click="quickSearchList('5',index = 6)">{{$t('fba.cancelled')}}</el-button>
            </div>
            <!-- <el-col> </el-col> -->
            <div>
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('common.reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('common.search')}}</el-button>
              <el-button class="search-btn btn-green" @click="newBuiltOrder">{{$t('fba.createPackList')}}</el-button>
              <el-button class="search-btn btn-blue" @click="toSort">{{$t('common.sort')}}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >{{$t('search.expandPanel')}}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >{{$t('search.retractPanel')}}</el-button>
            </div>
          </div>
        </el-row>
      </div>
      <!-- 内容 -->
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <lx-table :list="containerList" border stripe :rowKey="'id'" :emptyText="$t('select.select24')" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
          <el-table-column :show-overflow-tooltip="true" v-for="(item, index) in asyncColumns" :key="index" align="center"
            :label="item.name" :prop="item.key" :width="item.width?item.width:'auto'"
            :min-width="item.minWidth?item.minWidth:'auto'">
            <template v-slot="scope">
              <div v-if="item.key === 'handle'">
                <div class="btn-row" v-if="scope.row.containerState != 6 && scope.row.containerState != 5  ">
                  <el-button class="list-btn-four btn-blue" @click="toContainerDetail(scope.row)"> {{$t('fba.packDetail')}}
                  </el-button>
                </div>
                <div class="btn-row">
                  <el-button class="list-btn-four btn-deepblue" @click="ContainerOrderList(scope.row.containerBatchNo)">
                    {{$t('fba.packList')}}</el-button>
                </div>
                <div class="btn-row" v-if="scope.row.containerState == 1">
                  <el-button class="list-btn-four btn-red" @click="toOrderBillPay(scope.row)">{{$t('fba.pay')}}</el-button>
                </div>
                <div class="btn-row" v-if="
                  scope.row.containerState != 0 && scope.row.containerState != 1 && scope.row.containerState != 6
                && scope.row.containerState != 5 && scope.row.containerState != 7">
                  <el-button class="list-btn-four btn-green" @click="toOrderBill(scope.row)">{{$t('fba.bill')}}</el-button>
                </div>
                <div class="btn-row" v-if="scope.row.containerState == 6">
                  <el-button class="list-btn-four btn-red" @click="cannelBill(scope.row)">{{$t('common.cancel')}}</el-button>
                </div>
              </div>
              <div v-else-if="item.key === 'containerBatchNo'">
                {{scope.row.containerBatchNo}}
              </div>
              <div v-else-if="item.key === 'status'" class="lx-text-center">
                <div v-for="(item, i) in containerStateList" :key="i">
                  <div v-if="scope.row.containerState === item.value">
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <div v-else-if="item.key === 'invoice'">
                <el-upload action="/" :http-request="
                  (file) =>
                    uploadVideo(
                      scope.row.containerBatchNo,
                      scope.row.containerState,
                      file
                    )
                " accept=".pdf" :limit="1" :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadVideo">{{$t('common.upload')}} </el-button>
                </el-upload>
                <!-- <span  @click="downloadFile(scope.row)" style="cursor:pointer">{{scope.row.invoiceUrl}}</span> -->
                <a class="link" @click="downloadFile(scope.row)">{{ scope.row.invoiceUrl }}</a>
              </div>
              <div v-else-if="item.key === 'boxNum'">
                {{scope.row.containerBoxesCount}}
              </div>
              <div v-else-if="item.key === 'logisticsInfo'">
                <div class="lx-text-center">
                  {{scope.row.logisticeCompany}}
                </div>
                <div class="lx-text-center">

                  <span v-if="scope.row.sagawa === '1'">
                      <a target="_blank" :href="'http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=' + scope.row.waybillNumber">{{scope.row.waybillNumber}}</a>
                  </span>
<!--                  <span v-else-if="scope.row.sagawa === '2'">-->
<!--                      <a target="_blank" :href="'http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=' + scope.row.waybillNumber">{{scope.row.waybillNumber}}</a>-->
<!--                  </span>-->
                  <span v-else>
                     {{scope.row.waybillNumber}}
                  </span>

                </div>
                <div class="lx-text-center">
                  <div v-html="scope.row.logisticeState"></div>
                  <!-- <span v-for="(item, i) in containerStateList" :key="i">
                        <span v-if="scope.row.containerState === item.value">
                          {{ item.label }}
                        </span>
                      </span> -->
                </div>
              </div>
              <div v-else-if="item.key === 'receiver'">
                {{scope.row.recipientName}}
              </div>
              <div v-else-if="item.key === 'receiverCode'">
                {{scope.row.zipCode}}
              </div>
              <div v-else-if="item.key === 'putIntent'">
                <div>
                  <span>{{$t('select.select16')}}:</span>
                  <span>{{scope.row.recipientName}}</span>
                </div>
                <div>
                  <span>{{$t('OrderDetail.OrderDetail20')}}：</span>
                  <span>{{scope.row.zipCode}}</span>
                </div>
                <div>
                  <span>{{$t('OrderDetail.OrderDetail25')}}：</span>
                  <span>{{scope.row.deliveryAddress}}</span>
                </div>
              </div>
              <div v-else-if="item.key === 'senderAddress'">
                <div>
                  <span>{{$t('OrderDetail.OrderDetail19')}}：</span>
                  <span>{{scope.row.senderName}}</span>
                </div>
                <div>
                  <span>{{$t('OrderDetail.OrderDetail56')}}：</span>
                  <span>{{scope.row.senderZipCode}}</span>
                </div>
                <div>
                  <span>{{$t('OrderDetail.OrderDetail24')}}：</span>
                  <span>{{scope.row.senderAddress}}</span>
                </div>
              </div>
              <div v-else-if="item.key === 'route'">
                {{scope.row.route === '1' ? $t('FBAContainerOrder.FBAContainerOrder1'): $t('FBAContainerOrder.FBAContainerOrder2')}}
              </div>
              <div v-else-if="item.key === 'remark'">
                {{scope.row.comments}}
              </div>
              <div v-else-if="item.key === 'attachment'">
                  <el-upload v-if="scope.row.containerState == '6'" action="/" :http-request="(file) =>uploadAttachment(file,scope.row)" :limit="5" :show-file-list="false">
                    <el-button class="list-btn btn-blue" ref="uploadAttachment">{{$t('common.upload')}} </el-button>
                  </el-upload>
                  <el-tag v-for="(item,i) in getAttachment(scope.row.attachment)" :key="i" :closable="scope.row.containerState == '6'" size="medium" @click="viewAttachment(item)" @close="deleteAttachment(item,scope.row)" style="display: block;height: auto;text-align: left;white-space: normal;margin-top: 5px;">
                    {{item.name}}
                  </el-tag>
              </div>
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div>
              <div v-else-if="item.key === 'sendTime'">
                {{ scope.row.sendTime | dateFormatToSecond }}
              </div>
            </template>
          </el-table-column>
        </lx-table>
        <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 装箱单展示 -->
    <el-dialog :visible.sync="ContainerOrderListVisible" width="70%" @close="ContainerOrderDialogClosed">
      <!-- <el-button type="primary" style="margin-bottom:15px" @click="handleExport">
        {{$t('export')}}</el-button> -->
      <el-table :header-cell-style="tableStyle.headerStyle" :data="containerOrderList" border stripe style="width: 100%">
        <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="40"></el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('fba.orderNo')" width="70"></el-table-column>
        <!-- <el-table-column prop="fnsku" label="fnsku" align="center" width="90"></el-table-column> -->
        <el-table-column prop="goodsName" :label="$t('fba.goodsName')" min-width="200"></el-table-column>
        <el-table-column prop="pictureUrl" :label="$t('OrderDetail.OrderDetail54')" min-width="80">
          <template v-slot="scope">
            <img @click="imgclick(scope.row.pictureUrl)" :src="scope.row.pictureUrl" alt="" style="width:70px;height:70px">
          </template>
        </el-table-column>
        <el-table-column prop="orderType" label="FBA/YFF/ZOZO/RSL" align="center" min-width="90">
          <template v-slot="scope">
            <span v-if="scope.row.orderType == 0">FBA</span>
            <span v-if="scope.row.orderType == 1">{{$t('filter.filter36')}}</span>
            <span v-if="scope.row.orderType == 2">YFF</span>
            <span v-if="scope.row.orderType == 3">ZOZO</span>
            <span v-if="scope.row.orderType == 4">RSL</span>
          </template>
        </el-table-column>
        <el-table-column prop="fnsku" :label="$t('createOrder.createOrder24')" align="center" min-width="100"></el-table-column>
        <el-table-column prop="goodsNameCus" :label="$t('OrderDetail.OrderDetail55')" align="center" width="150">
          <template v-slot="scope">
            <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState')" width="90">
          <template v-slot="scope">
            <div v-for="(item, i) in orderStatusOptions" :key="i">
              <div v-if="scope.row.orderStatus == item.value">
                {{ item.label }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryFlag" :label="$t('fba.warehouseRetention')" align="center" width="90">
          <template v-slot="scope">
            {{scope.row.categoryFlag == 0 ? $t('running.suspended0') : $t('running.suspended1')}}
          </template>
        </el-table-column>
        <el-table-column prop="goodsCount" :label="$t('fba.goodsNumber')" align="center" width="120"></el-table-column>
        <!-- <el-table-column prop="waitingCount" :label="$t('fba.packingNumber')" align="center" width="90"></el-table-column> -->
        <!-- <el-table-column prop="badCount" :label="$t('fba.badToHandle')" align="center" width="100"></el-table-column>
        <el-table-column prop="exchangCount" :label="$t('fba.exchanging')" width="70"></el-table-column>
        <el-table-column prop="reissueCount" align="center" :label="$t('fba.reissuing')" width="70"></el-table-column> -->
        <el-table-column prop="refundCount" :label="$t('fba.returnNumber')" align="center" width="90"></el-table-column>
        <el-table-column prop="destroyCount" :label="$t('fba.destroyNumber')" align="center" width="90"></el-table-column>
        <el-table-column prop="netWeight" :label="$t('fba.netWeight')" align="center" width="90">
          <template v-slot="scope">
            <div>
              {{scope.row.netWeight.toFixed(3)}}
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="waitingCount" :label="$t('fba.canApplyCount')" align="center" width="90"></el-table-column>
        <el-table-column prop="containerGoodsCount" :label="$t('fba.applyNumber')" align="center" width="90"></el-table-column>
      </el-table>
      <!-- </div>  -->
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="ContainerOrderListVisible = false">{{$t('common.close')}}</el-button>
      </span>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
  </div>
</template>

<script>
import { columns as originColumns } from "./columns";
import { filterList } from "@/assets/js/utils";
import LxTable from '@/components/LxTable'
import LxSort from "@/components/LxSort/index";
import tableCon from "../../views/tableContainer";
export default {
  components: {
    LxTable,
    LxSort,
    tableCon,
  },
  data () {
    return {
      isActive:false,
      imgurl: '',
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      visible: false,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: 'FBA'
      },
      queryInfo: {
        containerBatchNo: "",
        logisticeCompany: "",
        customerId: "",
        realName: "",
        containerState: "",
        sendArea: "",
        createTimeStart: "",
        createTimeEnd: "",
        waybillNumber: "",
        route: "",

        pageSize: 10,
        pageNum: 1,
      },
      containerBatchNo: "",
      orderData: {
        waitPayNum: 0
      },
      containerStateList: [
        //装箱状态
        {
          value: "0",
          label: this.$t('fba.packing'),
        },
        {
          value: "1",
          label: this.$t('fba.toPay'),
        },
        {
          value: "2",
          label: this.$t('fba.toUploadInvoice'),
        },
        {
          value: "3",
          label: this.$t('fba.toSend'),
        },
        {
          value: "4",
          label: this.$t('fba.sent'),
        },
        {
          value: "5",
          label: this.$t('fba.cancelled'),
        }, {
          value: '6',
          label: this.$t('fba.toPack'),
        }, {
          value: '7',
          label: this.$t('fba.finishBox'),
        }
      ],
      routeList: [
        {
          value: "1",
          label: this.$t('FBAContainerOrder.FBAContainerOrder1'),
        },
        {
          value: "2",
          label: this.$t('FBAContainerOrder.FBAContainerOrder2'),
        },
      ],
      //订单状态
      orderStatusOptions: [],
      ContainerOrderListVisible: false,
      containerOrderList: [],
      //物流公司的下拉地址
      dropDownList: [],
      // containerDateRangeValue: [],
      containerList: [],

      total: 0,
    };
  },
  methods: {
    async uploadAttachment(file,row){
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        let {fileName, filePath} = res.data;
        let attachmentList = this.getAttachment(row.attachment)
        attachmentList.push({name: fileName, url: filePath})
        let attachment = '';
        if (attachmentList.length > 0) {
          attachment = JSON.stringify(attachmentList)
        }
        row.attachment = attachment
        const {data: updateAttachmentRes} = await this.$http.post('container/updateAttachment', {id: row.id, attachment: attachment});
        if (updateAttachmentRes.code !== 200) {
          this.$message.error(updateAttachmentRes.message);
        } else {
          this.$message({
            type: 'success',
            message: this.$t('common.submitSuccess'),
          });
        }
      }
    },
    viewAttachment(item){
      window.open(item.url, '_blank')
    },
    deleteAttachment(item,row){
      this.$confirm(this.$t('createOrder.createOrder68'),  {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        let attachmentList = this.getAttachment(row.attachment)
        for (let i = 0; i < attachmentList.length; i++) {
          let attach = attachmentList[i];
          if (item.url == attach.url) {
            attachmentList.splice(i, 1)
          }
        }
        let attachment = '';
        if (attachmentList.length>0){
          attachment = JSON.stringify(attachmentList)
        }
        const {data: res} = await this.$http.post('container/updateAttachment',{ id: row.id,attachment:attachment });
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: 'success',
            message: this.$t('common.submitSuccess'),
          });
          row.attachment = attachment
        }
      })
    },
    getAttachment (str){
      if (str != null && str.length > 0){
        return JSON.parse(str);
      }
      return []
    },
    imgclick (url, visible) {
      this.visible = true;
      this.imgurl = url;
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'FBA'
          }
        })
          .then((res) => {
            var result = [];
            if (res.data.code === 200) {
              var record = res.data.data;
              this.menuSettingData = record;
              result = JSON.parse(record.menuSetting);
            }
            if (result && result.length > 0) {
              result.forEach((item) => {
                this.$set(item, "isShow", true);
              });
              let noSelectList = filterList(
                this.originColumns,
                result,
                "columnId"
              );
              this.columns = result.concat(noSelectList);
              this.asyncColumns = result;
              resolve();
            } else {
              this.columns = this.originColumns;
              this.columns.forEach((item) => {
                this.$set(item, "isShow", true);
              });
              this.asyncColumns = this.columns;
              resolve();
            }
          });
      });
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this;
      var url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: this.$t('common.saveSuccess'),
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getContainerList();
          });
        } else {
          my.$message({
            type: "warning",
            message: this.$t('common.saveFailed'),
          });
        }
      });
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    containerDateRange () {
    },
    queryInfoClear () {
      this.queryInfo = {
        containerBatchNo: "",
        customerId: "",
        realName: "",
        containerState: "",
        logisticeCompany: "",
        sendArea: "",
        createTimeStart: "",
        createTimeEnd: "",
        waybillNumber: "",
        route: "",
        pageSize: 10,
        pageNum: 1,
      };
      // this.containerDateRangeValue = [];
      this.shipDateRangeValue = [];
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getContainerList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getContainerList();
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getContainerList();
      this.getStatisticalNum();
    },
    quickSearchList (val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1;
      this.queryInfo.containerState = val;
      this.getContainerList();
      this.getStatisticalNum();
    },
    dateFormat (time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // 拼接
      return year + '' + month + '' + day + '' + hours + '' + minutes;
    },
    handleExport () {
      let date = this.dateFormat(new Date())
      this.$http({
        url: "order/exportWaitPayOrder?containerBatchNo=" + this.ContainerInfo,
        method: 'get',
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `装箱申请P${date}.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch(() => {
      })
    },
    //上传pdf
    uploadVideo (containerBatchNo, containerState, file) {
      const isPDF = file.file.type === "application/pdf";
      if (!isPDF) {
        this.$message.error(this.$t('common.uploadOnlyPdf'));
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "FBAContainer");
      formdata.append("type", "PDF");
      this.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          const { data: res1 } = this.$http.post("container/uploadInvoice", {
            containerBatchNo: containerBatchNo,
            containerState: containerState,
            invoiceUrl: res.data.data,
          });
          this.$message.success(this.$t('common.uploadSuccess'));
          this.getContainerList();
          this.getStatisticalNum();
        }
      });
    },
    //下载文件
    async downloadFile (row) {
      let formdata = new FormData();
      formdata.append("fileUrl", row.pdfurl);
      formdata.append("fileName", row.invoiceUrl);
      var url = `${process.env.VUE_APP_BASE_URL}aliyun/oss/download`; // 请求的url + id
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader("client_type", "DESKTOP_WEB");
      xhr.setRequestHeader(
        "Authorization",
        window.sessionStorage.getItem("token")
      ); // 自定义请求头
      xhr.onload = function () {
        if (this.status == 200) {
          var blob = this.response;
          var fileName = row.invoiceUrl;
          if (window.navigator.msSaveOrOpenBlob) {
            // IE浏览器下
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send(formdata);
    },
    //检索全部的批次号
    async getContainerList () {
      const { data: res } = await this.$http.post(
        "container/getAllContainerList",
        this.queryInfo
      );
      this.containerList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum () {      //获取
      const { data: res } = await this.$http.get("/container/getStatisticalNum", { params: this.queryInfo });
      this.orderData = res.data;
    },
    //获取全部的物流公司
    async getDropDownList () {
      const { data: res } = await this.$http.post(
        "cms/logisticsCompany/getDropDownList"
      );
      this.dropDownList = res.data;
    },
    cannelBill (row) {
      this.$confirm(this.$t('fba.confirmCancelPackList'), {
        confirmButtonText: this.$t('common.confirm'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('common.cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post(`cmsContainer/modifyContainerOrder`, {
          id: row.id,
          containerState: 5,
          containerBatchNo: row.containerBatchNo
        });
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('common.cancelSuccess')
          });
          await this.getContainerList();
          this.getStatisticalNum();
        }
      }).catch((e) => {
        // console.log(e)
      });
    },
    ContainerOrderDialogClosed () {
      this.ContainerOrderListVisible = false;
    },
    ContainerOrderList (row) {
      this.ContainerOrderListVisible = true;
      this.ContainerInfo = row;
      this.getContainerOrderList();
    },
    //本批次下的装箱单
    async getContainerOrderList () {
      //  let formdata = new FormData()
      //  formdata.append("containerBatchNo",this.ContainerInfo);
      const {
        data: res,
      } = await this.$http.post("container/getContainerOrderList", {
        containerBatchNo: this.ContainerInfo,
      });
      this.containerOrderList = res.data;
    },
    //新建装箱单
    newBuiltOrder () {
      this.$router.push({
        name: "FBAContainerOrder",
      });
    },
    //支付
    toOrderBillPay (row) {
      this.$router.push({
        name: "FBABill",
        query: {
          containerBatchNo: row.containerBatchNo,
          isEdit: 1,
          containerState: row.containerState
        },
      });
    }, //账单
    toOrderBill (row) {
      this.$router.push({
        name: "FBABill",
        query: {
          containerBatchNo: row.containerBatchNo,
          isEdit: 0,
          containerState: row.containerState
        },
      });
    },
    dateFormatYMDHMS (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    toContainerDetail (row) {
      this.$router.push({
        name: "boxList",
        query: {
          containerBatchNo: row.containerBatchNo,
        },
      });
    },
    // 排序
    toSort () {
      this.isVisibleSort = true;
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // containerDateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.containerDateRangeValue) {
    //     this.containerDateRangeValue = [];
    //     this.queryInfo.createTimeStart = "";
    //     this.queryInfo.createTimeEnd = "";
    //   } else {
    //     if (this.containerDateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart =
    //           this.containerDateRangeValue[0] / 1000;
    //       this.queryInfo.createTimeEnd = this.containerDateRangeValue[1] / 1000;
    //     }
    //   }
    // },
    shipDateRangeValue () {
      if (!this.shipDateRangeValue) {
        this.shipDateRangeValue = [];
        this.queryInfo.sendTimeStart = "";
        this.queryInfo.sendTimeEnd = "";
      } else {
        if (this.shipDateRangeValue.length > 0) {
          this.queryInfo.sendTimeStart = this.shipDateRangeValue[0] / 1000;
          this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1] / 1000;
        }
      }
    },
  },
  created () {
    this.orderStatusOptions = [
      {
        value: "0",
        label: this.$t('fba.toWarehouse'),
      },
      {
        value: "1",
        label: this.$t('fba.fba7'),
      },
      {
        value: "2",
        label: this.$t('fba.fba8'),
      },
      {
        value: "4",
        label: this.$t('fba.warehoused'),
      },
      {
        value: "8",
        label: this.$t('fba.sampling'),
      },
      {
        value: "12",
        label: this.$t('fba.sampled'),
      },
      {
        value: "16",
        label: this.$t('fba.inStorage'),
      },
      {
        value: "20",
        label: this.$t('fba.applyForShipment'),
      },
      {
        value: "24",
        label: this.$t('fba.badToHandle'),
      },
      {
        value: "26",
        label: this.$t('fba.badReject'),
      },
      {
        value: "28",
        label: this.$t('fba.exchangeToReturn'),
      },
      {
        value: "32",
        label: this.$t('fba.exchangeToArrival'),
      },
      {
        value: "36",
        label: this.$t('fba.toPartiallyReturned'),
      },
      {
        value: "40",
        label: this.$t('fba.reissueToArrival'),
      },
      {
        value: "44",
        label: this.$t('fba.toPay'),
      },
      {
        value: "48",
        label: this.$t('fba.toSend'),
      },
      {
        value: "52",
        label: this.$t('fba.sent'),
      },
      {
        value: "56",
        label: this.$t('fba.cancelled'),
      },
      {
        value: "60",
        label: this.$t('fba.returnApplying'),
      },
      {
        value: "64",
        label: this.$t('fba.returnToPay'),
      },
      {
        value: "68",
        label: this.$t('fba.toReturn'),
      },
      {
        value: "72",
        label: this.$t('fba.returned'),
      },
      {
        value: "76",
        label: this.$t('fba.destroyToApply'),
      },
      {
        value: "80",
        label: this.$t('fba.destroyToPay'),
      },
      {
        value: "82",
        label: this.$t('fba.fba9'),
      },
      {
        value: "84",
        label: this.$t('fba.destroyed'),
      },
      {
        value: "88",
        label: this.$t('fba.sampled'),
      },
      {
        value: "89",
        label: this.$t('fba.fba10'),
      },
    ];
    this.getStatisticalNum();
    this.getAsyncColumns().then(() => {
      this.getContainerList();
    })
    this.getDropDownList();
  },
};
</script>
<style scoped>
.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}
.ta-l {
  text-align: left;
}
</style>
<style lang="less" scoped>
/deep/ .el-textarea__inner {
  color: #606266 !important;
}
.search-btn {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}
.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}
@media screen and (min-width: 1000px) and (max-width: 1550px) {
  .search-btn {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>

